import { initAdv, injectAdv } from '@sky-uk/sky-adv';

export const init = ($advIntroDataNode) => {
  injectAdv($advIntroDataNode);
  initAdv($advIntroDataNode);
};
